import React, {useState, useRef, useEffect} from "react";

// reactstrap components
import {
  Button, InputGroup, InputGroupText,
  Card,Badge,Spinner,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  FormGroup,
  Form,
  Input,
  Row,
  Col,
  Container,
} from "reactstrap";
import { useSelector , useDispatch} from 'react-redux'

import {fieldvalidator, filenamevalid, alphanum, alpha, numtests, numdtest,
    floattest, numtest} from '../../../helpers/validate'
import {customStyles} from '../../../helpers/mycomps'

import Select from "react-select";
import dp from "../../images/dp.jpg"

function Brandreq(props) {
    const [showProcessing , setShowProcessing] = useState(false)
    const [brandList, setBrandList] = useState([])
    const [selectedbrand, setSelectedBrand] = useState({
        bid : "", bname : {en : "", fr :"", ar : ""},
        blogo : ""
    })

    const [{alt, src}, setImg] = useState({
        src: dp,
        alt: ''
      });
      
    const [filenames, setFilenames] = useState()
    const hiddenFileInput = useRef(null);
    

    const cinputConfirmAlert = (xcc) => {
        let mtext = ""
        swal({
          title: "Are you sure?",
          text: "Are you sure that you want to request Brand?",
          icon: "warning",
          dangerMode: true,
        })
        .then(willDelete => {
          if (willDelete) {
            updbrand()
           
          
          }
        });
        
      };  

      const handleClick = event => {
        hiddenFileInput.current.click();
      };
   

    const handleImg = (e) => {
    
        if(e.target.files[0]) {
                
            if(filenamevalid(e.target.files[0])){
              setFilenames(e.target.files[0])
              setImg({
                src: URL.createObjectURL(e.target.files[0]),
                alt: e.target.files[0].name
            });
            }else{
              props.swal("Invalid Filename")
            }
        }
     
          
    }

    const updbrand = () => {
      if(fieldvalidator(selectedbrand.bname.en )){
        props.swal("Required Fields are EMPTY!")
        return 
      }
        setShowProcessing(true)
        let formData = new FormData(); 
        formData.append("blogo" , filenames)
        formData.append('brand' , JSON.stringify(selectedbrand))
        props.API({
            method: "post",
            url : `ten/brandreq`,
            data: formData
            }).then((res) => {
              props.swal("Brand request created!")
              setShowProcessing(false)
              props.setSbshow(false)
            }).catch(function (error) {
              setShowProcessing(false)
              if(error.response.status === 401){
                props.swal("Unauthorized, please login again.").then(t => {
                    props.history.push(`/auth/login`)
                })   
              }else{
                props.swal(error.response.data.message)
              }
              
              console.log("error")
        }) 

    }

    useEffect(() => {
    
        setSelectedBrand(props.selectedbrand)
    }, [props.selectedbrand])

   
     return (
      
        <div className="content">

             <input
         ref={hiddenFileInput}
         type="file" 
         accept=".png, .jpg, .jpeg" 
         id="photo" 
         className="visually-hidden"
         onChange={e=> handleImg(e)}
         hidden/>
      
        <Row>
            {/** This will contain Table */}
            <Col sm="12" md="12">
            {showProcessing ? <center><Spinner /></center> : 
            
             <Card>
                 <CardHeader>
              
                 <Row>
                 <Col>
                 <center>
                 <img className="mute-anim" src = {selectedbrand.blogo === "" ? src : `${selectedbrand.blogo}`} alt={"..."} width="150px"  onClick={e => {
                                handleClick(e)
                              }}/>
                   </center>
                 </Col>   
                 </Row>     
                                           
                 <Row>
                         <Col className="pr-1" md="6">
                         <FormGroup>
                             <label>Name EN</label>
                             <Input
                             value = {selectedbrand.bname.en}
                             placeholder="en"
                             type="text"
                              onChange={t => {
                                setSelectedBrand({...selectedbrand , bname : {...selectedbrand.bname, en : t.target.value}})
                                
                                }
                            }
                              
                             />
                         </FormGroup>
                         </Col>
                     {/**     <Col className="pr-1" md="4">
                         <FormGroup>
                             <label>Nom</label>
                             <Input
                           value = {selectedbrand.bname.fr}
                             placeholder="Nom"
                             type="text"
                             onChange={t => {
                                setSelectedBrand({...selectedbrand , bname : {...selectedbrand.bname, fr : t.target.value}})
                              }}
                             />
                         </FormGroup>
                         </Col> */}
                         <Col className="pr-1" md="6">
                         <FormGroup>
                             <label>اسم</label>
                             <Input
                              value = {selectedbrand.bname.ar}
                             placeholder="اسم"
                             type="text"
                             onChange={t => {
                                setSelectedBrand({...selectedbrand , bname : {...selectedbrand.bname, ar : t.target.value}})
                              }}
                             />
                         </FormGroup>
                         </Col>
                  </Row>
                 
           
                 </CardHeader>
                 <CardBody>
               
                 </CardBody>
                 <CardFooter>
                    
                     <Button size="sm" color="warning" style={{float : "right", display : props.selectedbrand.reqid !== "" ? "none" : "block" }} onClick={x => {
                        cinputConfirmAlert()
                     }}>Request</Button>
                 </CardFooter>
             </Card>}
         </Col>
           
        </Row>
        </div>
    )
}

export default Brandreq;